export default "__VITE_ASSET__Cu0YUjIx__"